import React from "react";
import Navbar from "./Navbar";
import Footer from "./Footer";
import "../styles/About.css";

// FontAwesome icons (npm i @fortawesome/fontawesome-free)
import { FaUsers, FaLightbulb, FaHandshake } from "react-icons/fa";

const About = () => {
  return (
    <>
      <Navbar />

      <section className="about-section">
        <div className="container">
          <h1>About Us</h1>
          <p>
            Zarkhani Nexus Solutions Pvt Ltd is a trusted name in the field of international import and export, delivering high-quality industrial products across global markets. We specialize in Mechanical Spare Parts, AC Tools & Accessories, Pneumatics, Electronic Repairs, Safety & PPE’s, and many more essential components for diverse industries. Our mission is simple yet powerful: we deal in your best interests, ensuring every product and service adds real value to your operations.
</p>

<p>
We provide a full product range for industries, offering all components that keep your production lines running efficiently. By discussing your needs with you, we carefully understand your requirements and advise solutions that precisely meet your production goals. Whether you require critical spare parts or specialized industrial tools, our team ensures timely delivery, reliable quality, and competitive pricing.
</p><p>
With a strong global network and a commitment to excellence, Zarkhani Nexus Solutions Pvt Ltd continues to be a dependable partner for companies seeking durable, efficient, and cost-effective industrial solutions. We take pride in building long-term relationships with our clients, supporting their growth with innovative products and outstanding service. Your success is our priority, and we are dedicated to powering your industry with the best.
          </p>
        </div>
      </section>

      {/* ---------- 3 Icon Boxes ---------- */}
      <section className="about-boxes">
        <div className="box">
          <FaUsers className="icon" />
          <h3>Our Team</h3>
          <p>Dedicated professionals who strive to deliver excellence.</p>
        </div>

        <div className="box">
          <FaLightbulb className="icon" />
          <h3>Our Vision</h3>
          <p>Innovating to meet the changing demands of the industry.</p>
        </div>

        <div className="box">
          <FaHandshake className="icon" />
          <h3>Our Commitment</h3>
          <p>Building trust and long-lasting relationships with our clients.</p>
        </div>
      </section>

      <Footer />
    </>
  );
};

export default About;
